module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.google.title":"Google Cloud Connections","settings.google.subtitle":"All cloud connections importing GCP usage data in this tenant."}}')
  delete Component.options._Ctor
}
